import { Box, Button, InputAdornment } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RegenerateConfirmationModal } from '../pages/OrganizationDetails/RegenerateConfirmationModal';
import { OrganizationSecret } from '../services/organization/types';
import { OrganizationId } from '../types/idFlavors';

const styles = {
    regenerateButton: {
        textTransform: 'uppercase',
        borderRadius: '50px',
        width: '100%',
    },
};

type RegenerateButtonProps = {
    secretName: string;
    organizationName: string;
    organizationId: OrganizationId;
    setSecret: (updatedSecret: OrganizationSecret) => void;
    btnStyle?: object;
};

export const RegenerateButton: React.FC<RegenerateButtonProps> = (props) => {
    const { secretName, organizationName, organizationId, setSecret, btnStyle } = props;
    const { t } = useTranslation();

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    return (
        <Box>
            <InputAdornment position="end">
                <Button
                    data-testid={`regenerate-${secretName}-button`}
                    sx={btnStyle ?? styles.regenerateButton}
                    variant="contained"
                    color="primary"
                    onClick={(): void => {
                        setShowConfirmationModal(true);
                    }}
                >
                    {t('ORGANIZATION_DETAILS_PAGE.REGENERATE_BUTTON')}
                </Button>
            </InputAdornment>
            {showConfirmationModal && (
                <RegenerateConfirmationModal
                    secretName={secretName}
                    organizationName={organizationName}
                    organizationId={organizationId}
                    setShowConfirmationModal={setShowConfirmationModal}
                    setSecret={setSecret}
                />
            )}
        </Box>
    );
};
